<organism-modal modalTitle="Avatar Information">
    <molecule-avatar-info [avatar]="avatar"></molecule-avatar-info>
</organism-modal>
